import { localStorageSet } from 'helpers/localStorage';
import { REFRESH_TABS_LOCAL_STORAGE_KEY } from 'helpers/refreshTabs/constants';
export const triggerOtherTabsToRefresh = () => {
    localStorageSet(REFRESH_TABS_LOCAL_STORAGE_KEY, 'true');
};
